export default "__VITE_ASSET__Duf1bNqC__"